// JWT живёт только в памяти вкладки (docs/07-miniapp-ux.md §3): не localStorage,
// чтобы токен не пережил закрытие Mini App и не читался сторонним скриптом на странице.
let token: string | null = null;

export function getToken(): string | null {
  return token;
}

export function setToken(value: string): void {
  token = value;
}

export function clearToken(): void {
  token = null;
}
